import { render, staticRenderFns } from "./refsList.vue?vue&type=template&id=000526b0&"
import script from "./refsList.vue?vue&type=script&lang=js&"
export * from "./refsList.vue?vue&type=script&lang=js&"
import style0 from "./refsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports